import React from 'react'

import StickyCommentInput from '../StickyCommentInput'

import { WarningText } from './AnnotationCommentBox.styles'
import { Banner, Link } from '@sketch/components'
import { useIsAnnotationPreview } from '../../context'
import type { CommentInputProps } from '../CommentInput'

interface AnnotationCommentBoxProps
  extends Omit<CommentInputProps, 'banner' | 'disableMentions'> {
  showOlderVersionWarning: boolean
  /**
   * URL of the latest version of the document. Shown in the "you're viewing an
   * older version" warning banner. Required when `showOlderVersionWarning` is
   * true; ignored otherwise.
   */
  latestVersionUrl?: string
}

const VersionWarningText = ({
  latestVersionUrl,
}: {
  latestVersionUrl: string
}) => (
  <Banner type="warning" showIcon={false}>
    <WarningText>
      You’re viewing an older version. Comments will be added to the{' '}
      <Link to={latestVersionUrl} variant="secondary" isUnderlined>
        latest version
      </Link>
      .
    </WarningText>
  </Banner>
)

const AnnotationCommentBox = ({
  showOlderVersionWarning,
  latestVersionUrl,
  ...props
}: AnnotationCommentBoxProps) => {
  const disableMentions = useIsAnnotationPreview()

  const banner =
    showOlderVersionWarning && latestVersionUrl ? (
      <VersionWarningText latestVersionUrl={latestVersionUrl} />
    ) : undefined

  return (
    <StickyCommentInput
      banner={banner}
      disableMentions={disableMentions}
      {...props}
    />
  )
}

export default AnnotationCommentBox
